import $ from "jquery";
/* eslint-disable */
import slick from "slick-carousel";
/* eslint-enable */

function throttle(func, timeFrame) {
  let lastTime = 0;
  return function inner(...args) {
    const now = new Date();
    if (now - lastTime >= timeFrame) {
      func(...args);
      lastTime = now;
    }
  };
}

const elements = {
  navigationElement: document.querySelector('.c-anchor-links'),
  navigationBar: document.querySelector('.c-anchor-links-nav'),
  navigationLinks: document.querySelectorAll('.c-anchor-links-icon'),
  sections: document.querySelectorAll('.c-anchor-links__section'),
};

function navHighlighter() {
  const scrollY = window.pageYOffset;
  elements.sections.forEach((current) => {
    const sectionHeight = current.offsetHeight;
    const sectionTop = (current.getBoundingClientRect().top + window.pageYOffset)
    - elements.navigationBar.offsetHeight;
    const sectionId = current.getAttribute('data-section');
    if (
      scrollY > sectionTop &&
      scrollY <= sectionTop + sectionHeight
    ) {
      document.querySelector(`.c-anchor-links-icon[data-section*=${sectionId}]`).classList.add('c-anchor-links-icon--active');
    } else {
      document.querySelector(`.c-anchor-links-icon[data-section*=${sectionId}]`).classList.remove('c-anchor-links-icon--active');
    }
  });
}

function scrollToElement(element, offset) {
  const elementPosition = element.getBoundingClientRect().top;
  const offsetPosition = (elementPosition + window.pageYOffset) - offset;

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  });
}

function smoothScroll() {
  function clickHandler(e) {
    e.preventDefault();
    const id = this.getAttribute('data-section');
    const section = document.querySelector(`.c-anchor-links__section[data-section*=${id}] .c-anchor-links__heading`);
    scrollToElement(section, elements.navigationBar.offsetHeight + 15);
  }

  elements.navigationLinks.forEach((item) => {
    item.addEventListener('click', clickHandler);
  });
}

const slickelements = {
  $carousels: $(".js-anchor-carousel-slider"),
};

const matchMobileWidth = window.matchMedia("(max-width: 31.25em)");

function toggleCarousel(match, carousel) {
  match ? setCarousel(carousel) : removeCarousel(carousel);
}

function setCarousel(carousel) {
  if (carousel.el.hasClass("slick-initialized")) return;

  if (!carousel.showDesktop) {
    carousel.el.slick({
      dots: carousel.dots,
      speed: 800,
      slidesToShow: carousel.mobileSlidesToShow,
      slidesToScroll: 2,
      infinite: false,
      arrows: true,
      rows: carousel.mobileRows,
      variableWidth: true,
      slidesPerRow: 1,
    });
  } 
  if (carousel.arrows) {
    carousel.next.show();
    carousel.prev.show();
  }
  setButtonStyling(carousel, 1);
}

function removeCarousel(carousel) {
  if (!carousel.el.hasClass("slick-initialized")) return;
  carousel.el.slick("unslick");
  carousel.next.hide();
  carousel.prev.hide();
}

function setButtonStyling(carousel) {
  toggleArrowState(carousel);
  const currentSlide = carousel.el.slick("slickCurrentSlide");
  const slides = carousel.slides.length;

  if (
    currentSlide + carousel.el.slick("slickGetOption", "slidesToShow") >=
      slides ||
    (currentSlide + 1) * carousel.el.slick("slickGetOption", "slidesPerRow") >=
      slides ||
    (currentSlide + 1) * carousel.el.slick("slickGetOption", "rows") >= slides
  ) {
    carousel.next.addClass("is-disabled");
  } else {
    carousel.next.removeClass("is-disabled");
  }

  if (currentSlide === 0) {
    carousel.prev.addClass("is-disabled");
  } else {
    carousel.prev.removeClass("is-disabled");
  }
}

function toggleArrowState(carousel) {
  if (
    carousel.el.slick("slickGetOption", "slidesToShow") !==
    carousel.slides.length
  ) {
    carousel.next.show();
    carousel.prev.show();
  } else {
    carousel.next.hide();
    carousel.prev.hide();
  }
}

function init() {
  if (slickelements.$carousels.length > 0) {

    slickelements.$carousels.each((index, el) => {
      const parent = $(el).parent();
      const carousel = {
        el: $(el),
        slides: parent.find(".js-anchor-carousel-slide"),
        next: parent.find(".js-anchor-carousel-next"),
        prev: parent.find(".js-anchor-carousel-prev"),
        dots: parent.data("dots") || false,
        arrows: parent.data("arrows") || false,
        showDesktop: parent.data("showDesktop") || false,
        mobileSlidesToShow: parent.data("mobileSlidesToShow") || 1.3,
        mobileSlidesToScroll: parent.data("mobileSlidesToScroll") || 1,
        mobileRows: parent.data("mobileRows") || 1,
        mobileSlidesPerRow: parent.data("mobileSlidesPerRow") || 1,
        desktopSlidesToShow: parent.data("desktopSlidesToShow") || 3,
        desktopSlidesToScroll: parent.data("desktopSlidesToScroll") || 1,
        desktopRows: parent.data("desktopRows") || 1,
        desktopSlidesPerRow: parent.data("desktopSlidesPerRow") || 1,
      };

      if (carousel.el && carousel.slides.length > 0) {
        if (carousel.slides.length < 1) return carousel.el.parent().show();

        carousel.prev.on("click", () => {
          carousel.el.slick("slickPrev");
        });

        carousel.next.on("click", () => {
          carousel.el.slick("slickNext");
        });

        carousel.el.on("afterChange", (e, slick, currentSlide) => {
          setButtonStyling(carousel, currentSlide);
        });

        if (!carousel.showDesktop) {
          parent.addClass("is-mobile-only");
          matchMobileWidth.addEventListener("change", (e) => {
            toggleCarousel(e.matches, carousel);
          });
          toggleCarousel(matchMobileWidth.matches, carousel);
        } else {
          setCarousel(carousel);
        }
      }
    });
  }

  if (elements.navigationElement) {
    smoothScroll();
    window.addEventListener('scroll', throttle(navHighlighter, 10));
  }
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/consumer/anchor-links/anchor-links.js